<script lang="typescript">
    import Router from "svelte-spa-router";
    import Tailwindcss from "./Tailwindcss.svelte";
    import { routes } from "./routes.js";
</script>

<svelte:head>
    <link href="/fonts/stylesheet.css" rel="stylesheet" />
</svelte:head>

<Tailwindcss />

<main class="relative flex flex-col justify-center w-screen h-full p-0 m-0">
    <Router {routes} />
</main>
